/**
 * @export
 * @class PromotionBanner
 * 마케팅 배너
 */
export default class PromotionBanner {
  constructor() {
    // 필요 data 유효 확인
    const { stickers } = TMON.oApp.htStorage.htStaticData.htDealInfo;
    if (!stickers || stickers.length < 1) return;

    this.sWrapper = '_wrapPromotionBanner';
    this.welWrapper = $(`#${this.sWrapper}`);

    this.setEvent();
    this.render();
  }

  setEvent() {
    // 앱에서 링크 이동 eventListener 등록
    if (TMON.view_mode === 'app') {
      this.welWrapper.on('click', 'a', this.onClickPromotionBanner);
    }
  }

  clearEvent() {
    if (TMON.view_mode === 'app' && this.welWrapper) {
      this.welWrapper.off('click', 'a');
    }
  }

  /**
   * 앱에서 링크 이동 eventListener
   */
  onClickPromotionBanner = e => {
    TMON.app.callApp('link', 'goEvent', e.currentTarget.href);
    e.preventDefault();
  };

  render() {
    const { stickers } = TMON.oApp.htStorage.htStaticData.htDealInfo;

    let sHtml = '';
    sHtml = `<div class="deal_sticker">
                ${stickers
                  .map((item, i) => {
                    const planId = /\/(\w+)$/g.exec(
                      item.stickerMobileDetailUrl
                    );
                    return item.stickerMobileDetailUrl &&
                      item.stickerMobileDetailImg
                      ? `<a href="${
                        TMON.util.preventMixedContent(
                          TMON.util.aup(
                            item.stickerMobileDetailUrl,
                            TMON.sAppQuery
                          )
                        )}" data-tlarea="M123EV" data-tlord="${i +
                          1}" data-tldimension="title:${
                          item.stickerTitle
                        }__plan_id:${planId ? planId[1] : item.targetUrl}" >
                                    <img src="${
                                      TMON.util.preventMixedContent(item.stickerMobileDetailImg)
                                    }" alt="${item.stickerTitle}" />
                                </a>`
                      : '';
                  })
                  .join('')}
            </div>`;
    this.welWrapper.html(sHtml);

    if ($(`#${this.sWrapper} .deal_sticker > a`).length > 0) {
      this.welWrapper.show();
    } else {
      this.welWrapper.remove();
    }
  }
}
